import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { FetchParam } from "app/services/fetchService";

import { sitesOptions } from "../queries/sitesQueries";
import type { ISimilarInfoItem, SimilarSitesQueryOptions } from "../types";

export const useSimilarSites = (
    domain: string,
    params?: FetchParam,
    options?: SimilarSitesQueryOptions,
): UseQueryResult<ISimilarInfoItem[]> => {
    return useQuery({
        ...sitesOptions.similarSites(domain, params, options),
    });
};
